import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";

export const fetchAgentsList = createAsyncThunk(
  "agentList/fetchAgentsList",
  async () => {
    return httpRequest(`${BASE_URL}/Orders/AgentLookup`);
  }
)

const agentLookUpSlice = createSlice({
  name: 'agentList',
  initialState: {
    agentList: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgentsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgentsList.fulfilled, (state, action) => {
        state.loading = false;
        state.agentList = action.payload;
      })
      .addCase(fetchAgentsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default agentLookUpSlice.reducer;

